//
import GBarAuthorizationModel from '@/models/General/GBarAuthorization'

//
export default class GBarAuthorizationService {

  /**
   * Get the bar authorization data by provided code
   * @param {*} code 
   * @return {Promise}
   */
  static getByCode(code) {
    return this
      .model()
      .params({
        auth_code: code,
        permission: 'access_to%20point_sale',
      })
      .get()
  }

  /**
   *  Returns the model
   */
  static model() {
    return GBarAuthorizationModel
  }
}